import { ApolloClient, HttpLink, InMemoryCache, from } from '@apollo/client/core';
import { piezoLink } from './client/piezo/signing/piezoLink';

const httpLink = new HttpLink({ uri: '/graphql' });

/**
 * The single Apollo client for the app. Exported rather than created inline in index.tsx so imperative
 * call sites outside the React tree share the same link chain — anything that posts to /graphql by hand
 * bypasses piezoLink, and the server rejects a migrated tool with no operator artifact.
 */
export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  // piezoLink runs before httpLink: it attaches an operator-signed Piezo artifact to every
  // migrated tool operation on its way to the BFF. Non-migrated operations pass through untouched.
  link: from([piezoLink, httpLink]),
});
